export default __webpack_public_path__ + "static/media/frutas2.7dd00e58.jpg";